import { BASE_URL_PROD } from '../../components/config/keys';
import React, { useEffect, useState, useRef } from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { useDispatch, useSelector } from "react-redux"
import { Container, Row, Col, Modal, CloseButton } from "react-bootstrap"
import { useHistory } from "react-router";
import { apiClient } from "../../actions/api"
import moment from 'moment'
import 'moment/locale/fr';
import Countdown from 'react-countdown';
import { soundnotification } from "../../assets/images";
import ErrorBoundary from "../../helpers/ErrorBoundary";
import { usePusher } from "../../PusherContext";

const Page = () => {
  const dispatch = useDispatch();
  const history = useHistory()
  const [show, setShow] = useState(false);
  const { user } = useSelector(state => state.user);
  const { i18n } = useTranslation();
  const [checkconsultation, setCheckconsultation] = useState({})
  const [therapeute, setTherapeut] = useState([])
  const audioPlayer = useRef(null);
  const [timecall, setTimeCall] = useState(100000)
  const [startcall, setstartcall] = useState(false)
  const pusher = usePusher();
  const pollIntervalRef = useRef(null);

  useEffect(() => {
    if (!user.user_id || user.google_id !== 'A') {
      history.replace("/")
    }

    checkifconsultation()
  }, [user]);

  function checkifconsultation() {
    let params = {
      token: user.api_token,
      api_token: user.api_token,
    }

    apiClient().post(`/getconsultation/therapeut`, params)
      .then((res) => {
        if (res.data.success === 'ok') {
          if (res.data.reservation?.heure_rdv) {
            setCheckconsultation(res.data.reservation)
            setTherapeut(res.data.patients?.therapeute)

            let checkconsultationid = res.data.reservation.id
            let date = moment.utc(res.data.reservation.date_rdv + "T" + res.data.reservation.heure_rdv + "Z")
            let diff = date.diff(moment.utc(), 'seconds')

            if (diff <= 0) {
              setTimeCall(0)
            }
            else {
              setTimeCall(diff * 1000)
            }

            // 🎯 PUSHER : Écouter l'événement du thérapeute
            let idchanel = res.data.patients?.therapeute?.user_id + '__call__' + user?.user_id

            const channel = pusher.subscribe(idchanel);
            channel.bind('chat', function (data) {
              console.log("📢 Notification Pusher reçue : le thérapeute a démarré !");
              
              // Nettoyer le polling
              if (pollIntervalRef.current) {
                clearInterval(pollIntervalRef.current);
                pollIntervalRef.current = null;
              }
              
              // Rediriger vers la room Vonage
              history.push('/room-call/' + checkconsultationid + "/r");
            });

            // 🎯 POLLING BACKUP : Vérifier toutes les 3 secondes si la session Vonage existe
            startPollingForSession(checkconsultationid);
          }
          else {
            // Pas de consultation
            // history.push('/')
          }
        }
      })
  }

  // 🔄 Fonction de polling pour détecter la création de la session Vonage
  const startPollingForSession = (consultationId) => {
    pollIntervalRef.current = setInterval(() => {
      let params = {
        token: user.api_token,
        api_token: user.api_token,
        id: consultationId
      }

      apiClient().post(`/roomtoken`, params)
        .then((res) => {
          if (res.data.success === 'ok' && res.data.room) {
            console.log("✅ Session Vonage détectée (polling) !");
            
            // Nettoyer le polling
            if (pollIntervalRef.current) {
              clearInterval(pollIntervalRef.current);
              pollIntervalRef.current = null;
            }
            
            // Rediriger vers la room Vonage
            history.push('/room-call/' + consultationId + "/r");
          }
        })
        .catch(err => {
          console.log("⏳ Session Vonage pas encore créée...");
        });
    }, 5000); // Vérifier toutes les 3 secondes
  };

  // Nettoyer le polling au démontage du composant
  useEffect(() => {
    return () => {
      if (pollIntervalRef.current) {
        clearInterval(pollIntervalRef.current);
        pollIntervalRef.current = null;
      }
    };
  }, []);

  const handleClose = () => setShow(false);

  const renderer = ({ hours, minutes, seconds, completed }) => {
    if (completed) {
      setstartcall(true)
      return (
        <span> "Maintenant"</span>
      )
    } else {
      return (
        <span> {hours}h:{minutes}m:{seconds}s</span>
      )
    }
  };

  return (
    <div className="home dayli">
      <section className="section2">
        <ErrorBoundary>
          <Container className='listtherapeutes'>
            <div className='row'>
              <Col md={6}>
                <div className='therapeutescontent'>
                  <div className="home-screen">
                    <div className='alert alert-warning' style={{ width: '100%' }}>
                      <div style={{}}>
                        <div style={{ marginBottom: '10px' }}></div>

                        <strong>Votre prochaine consultation commence
                          {
                            startcall
                              ? <span> Maintenant</span>
                              : <span> dans
                                {
                                  timecall > 1000 * 60 * 60 * 24
                                    ? <span> plus d'un jour</span>
                                    : <Countdown date={Date.now() + timecall} renderer={renderer} />
                                }
                              </span>
                          }
                        </strong>
                        <br /> <br />
                        <div style={{ marginBottom: '20px' }}></div>
                        Veuillez attendre que votre praticien ait démarré la consultation en ligne
                      </div>
                      <div style={{ marginBottom: '10px' }}></div>
                    </div>

                    <p className="small">Sélectionnez "Autoriser" pour utiliser votre caméra et votre micro pour cet appel si vous y êtes invité.</p>
                  </div>
                </div>
              </Col>

              <Col md={1}></Col>

              <Col md={5}>
                {/* Lister le praticien */}
                <div className='therapeutescontent'>
                  <Row className=''>
                    <Col md={12}>
                      <div className='row'>
                        <div className="text-center flowpriceheader">
                          <h2>Votre praticien</h2>
                        </div>
                      </div>
                      <div className='row ps-block--site-features ps-block--site-features-2' style={{ marginBottom: '30px' }}>
                        <div className='col-md-6'>
                          <div className='itemimg' style={{
                            backgroundImage: therapeute?.picture
                              ? `url(${BASE_URL_PROD + "gestion/public/uploads/" + therapeute?.picture})`
                              : "url('/images/default-profile.png')",
                            width: '90px',
                            margin: '0 auto',
                            height: '90px'
                          }}></div>
                          <h3 className='title'>{therapeute?.name}</h3>
                        </div>
                      </div>

                      <div className='therapeutescontent'>
                        <div className='flexrowtarifs row'>
                          <div className='col-md-12'>
                            <div className="text-center flowpriceheader">
                              <img src={checkconsultation?.tarif?.image} alt="tarif" />
                              <h2>{getTranslation(checkconsultation?.tarif?.titre, i18n.language)}</h2>
                            </div>
                          </div>

                          <div className='item'>
                            <div className='pricebox' style={{ boxShadow: 'none' }}>
                              <h3>{getTranslation(checkconsultation?.formule?.titre, i18n.language)}</h3>
                              <h4>{parseFloat(checkconsultation?.formule?.price).toFixed(2)}€<span><sup>/séance</sup></span></h4>
                              <div className="pricebox-border2"></div>
                              <div className='ttcontent'>
                                <ul className='col-9028-K'>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.temps} min</li>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.seance} {checkconsultation?.formule?.seance > 1 ? 'séances' : 'séance'}</li>
                                  <li><i className='fa fa-check-circle icochecked'></i> {checkconsultation?.formule?.pack}</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>

                    <Col md={3}>
                      <div className='actionrdv'>
                        <div className="text-center"></div>
                      </div>
                    </Col>
                  </Row>
                </div>
                {/* End */}
              </Col>
            </div>
            <audio ref={audioPlayer} src={soundnotification} />
          </Container>
        </ErrorBoundary>
      </section>

      <Modal show={show} onHide={handleClose} className='modelhermixtarif' size="xl" aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header>
          <CloseButton variant="dark" onClick={handleClose} />
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>
    </div>
  );
}

export default Page;